import env from 'core/env';

let basisLoader;

const pairs = (obj) => Object.keys(obj).map((k) => [k, obj[k]]);

let ktxLoader;

const CompressedTextureCache = new Map();

let CompressedFormat;
const pickFormat = (renderer) => {
    if (CompressedFormat) return CompressedFormat;

    let format = pairs({
        ktx: renderer.extensions.get('WEBGL_compressed_texture_pvrtc'),
        // astc: renderer.extensions.get('WEBGL_compressed_texture_astc'),
        // etc1: renderer.extensions.get('WEBGL_compressed_texture_etc1'),
        // s3tc: renderer.extensions.get('WEBGL_compressed_texture_s3tc')
    }).find((f) => f[1]);

    const hasCompressedFormat = !!format;
    CompressedFormat = hasCompressedFormat ? format[0] : 'basis';

    return CompressedFormat;
};

export default function loadCompressed(url, renderer) {
    if (CompressedTextureCache.has(url)) {
        return Promise.resolve(CompressedTextureCache.get(url));
    }

    return Promise.all(['three/examples/jsm/loaders/BasisTextureLoader', 'three/examples/jsm/loaders/KTXLoader'])
        .catch(() => {
            console.warn('Could not load BasisTextureLoader / KTXLoader. Is three installed?');
        })
        .then(([{ BasisTextureLoader }, { KTXLoader }]) => {
            if (!basisLoader) {
                basisLoader = new BasisTextureLoader();
                basisLoader.setTranscoderPath(`${env.CDN}static/three/basis/`);
            }

            if (!ktxLoader) {
                ktxLoader = new KTXLoader();
            }

            const format = pickFormat(renderer);

            basisLoader.detectSupport(renderer);

            url = url.replace(/#txt/, '');
            url = url.replace(/#ct/, '');
            url = url.replace(/\.jpg$/, '.' + format);
            url = url.replace(/\.png$/, '.' + format);

            return new Promise((resolve, reject) => {
                const data = CompressedTextureCache.get(url);

                const loader = format === 'basis' ? basisLoader : ktxLoader;
                loader.load(
                    url,
                    (d) => {
                        CompressedTextureCache.set(url, d);
                        resolve(d);
                    },
                    () => {},
                    (e) => {
                        reject(e);
                        throw new Error('Whoops! → ' + url + ' → ' + e); // rejects the promise
                    },
                );
            });
        });
}
